import React, { useEffect } from 'react';
import { Typography, Row, Col, Card } from 'antd';
import PageLayout from '../../components/layout/Layout';
import './index.css';
import AppHeader from '../../components/Header';

const { Title, Paragraph } = Typography;

const AboutPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AppHeader />
      <div className="about-container" style={{paddingTop: 72}}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Title level={2}>About Us</Title>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            <Card className="about-card">
              <Title level={3}>Our Story</Title>
              <Paragraph>
              At Market Finder, we are dedicated to making insurance more accessible, transparent, and convenient. We specialize in collecting, organizing, and displaying comprehensive insurance policy data to help individuals and businesses make informed decisions. Our platform ensures that users can compare coverage options, benefits, and costs with ease, empowering them to choose the best policies for their needs.
              </Paragraph>

              <Title level={3}>Our Mission</Title>
              <Paragraph>
              Our mission is to simplify the insurance process by providing accurate, up-to-date policy information from trusted providers. We aim to bridge the gap between insurers and policyholders, ensuring that everyone has access to clear, reliable, and unbiased insurance insights.


              </Paragraph>

              <Title level={3}>Our Values</Title>
              <Paragraph>
              <b>Excellence in Service –</b> We prioritize accuracy and efficiency in delivering policy information. <br />
              <b>Integrity in Business –</b> Transparency and trust are at the core of everything we do. <br />
              <b>Innovation and Growth –</b> We continuously enhance our platform to improve user experience. <br />
              <b>Customer Satisfaction –</b> We focus on helping users find the right coverage with confidence. <br />
              <b>Community Engagement –</b> We believe in educating and supporting our community about insurance choices.
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} lg={8}>
            <Card className="about-sidebar-card">
              <Title level={3}>Quick Facts</Title>
              <Paragraph>
                • Founded: 2024<br />
                • Locations: Worldwide<br />
                • Team Members: 50+<br />
                • Partners: 100+
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AboutPage; 